/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as RootRouteImport } from './routes/root'
import { Route as HomeRouteImport } from './routes/home'
import { Route as AuthRedirectRouteImport } from './routes/auth-redirect'
import { Route as ApiDocsRouteImport } from './routes/api-docs'
import { Route as FrameRouteImport } from './routes/_frame'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as InvitationsIndexRouteImport } from './routes/invitations/index'
import { Route as InvitationTypesIndexRouteImport } from './routes/invitation-types/index'
import { Route as ApiDocsIndexRouteImport } from './routes/api-docs/index'
import { Route as LayoutSensoryRouteImport } from './routes/layout/sensory'
import { Route as LayoutFrameRouteImport } from './routes/layout/frame'
import { Route as ApiDocsFarmgridRouteImport } from './routes/api-docs/farmgrid'
import { Route as ApiDocsConexRouteImport } from './routes/api-docs/conex'
import { Route as UsersUserNumberIndexRouteImport } from './routes/users/$userNumber/index'
import { Route as SensoryManufacturersIndexRouteImport } from './routes/sensory/manufacturers/index'
import { Route as SensoryDistributorsIndexRouteImport } from './routes/sensory/distributors/index'
import { Route as SensoryDevicesIndexRouteImport } from './routes/sensory/devices/index'
import { Route as SensoryDeviceTypesIndexRouteImport } from './routes/sensory/device-types/index'
import { Route as SensoryDeviceProfilesIndexRouteImport } from './routes/sensory/device-profiles/index'
import { Route as SensoryDeviceManagementIndexRouteImport } from './routes/sensory/device-management/index'
import { Route as SensnetSensingStationsIndexRouteImport } from './routes/sensnet/sensing-stations/index'
import { Route as SensnetNetworkSitesIndexRouteImport } from './routes/sensnet/network-sites/index'
import { Route as SensnetNetworkCorridorsIndexRouteImport } from './routes/sensnet/network-corridors/index'
import { Route as RemaRolesIndexRouteImport } from './routes/rema/roles/index'
import { Route as RemaResourceTypesIndexRouteImport } from './routes/rema/resource-types/index'
import { Route as RemaResourceInstancesIndexRouteImport } from './routes/rema/resource-instances/index'
import { Route as RemaPoliciesIndexRouteImport } from './routes/rema/policies/index'
import { Route as RemaGroupsIndexRouteImport } from './routes/rema/groups/index'
import { Route as RemaControlPlaneResourceInstancesIndexRouteImport } from './routes/rema/control-plane-resource-instances/index'
import { Route as OrganizationsOrganizationNumberIndexRouteImport } from './routes/organizations/$organizationNumber/index'
import { Route as EventsEventTypesIndexRouteImport } from './routes/events/event-types/index'
import { Route as EventsEntityTypesIndexRouteImport } from './routes/events/entity-types/index'
import { Route as EventsActionsIndexRouteImport } from './routes/events/actions/index'
import { Route as UsersUserNumberEditRouteImport } from './routes/users/$userNumber_.edit'
import { Route as SensoryManufacturersManufacturerNumberRouteImport } from './routes/sensory/manufacturers/$manufacturerNumber'
import { Route as SensoryDistributorsDistributorNumberRouteImport } from './routes/sensory/distributors/$distributorNumber'
import { Route as SensoryDevicesDeviceNumberRouteImport } from './routes/sensory/devices/$deviceNumber'
import { Route as SensoryDeviceTypesDeviceTypeNumberRouteImport } from './routes/sensory/device-types/$deviceTypeNumber'
import { Route as SensoryDeviceProfilesDeviceProfileNumberRouteImport } from './routes/sensory/device-profiles/$deviceProfileNumber'
import { Route as SensnetSensingStationsStationNumberRouteImport } from './routes/sensnet/sensing-stations/$stationNumber'
import { Route as SensnetNetworkSitesSiteNumberRouteImport } from './routes/sensnet/network-sites/$siteNumber'
import { Route as SensnetNetworkCorridorsCorridorNumberRouteImport } from './routes/sensnet/network-corridors/$corridorNumber'
import { Route as RemaRolesAddRouteImport } from './routes/rema/roles/add'
import { Route as RemaRolesRoleNumberRouteImport } from './routes/rema/roles/$roleNumber'
import { Route as RemaResourceTypesAddRouteImport } from './routes/rema/resource-types/add'
import { Route as RemaResourceTypesResourceTypeNumberRouteImport } from './routes/rema/resource-types/$resourceTypeNumber'
import { Route as RemaResourceInstancesAddRouteImport } from './routes/rema/resource-instances/add'
import { Route as RemaResourceInstancesInstanceNumberRouteImport } from './routes/rema/resource-instances/$instanceNumber'
import { Route as RemaPoliciesAddRouteImport } from './routes/rema/policies/add'
import { Route as RemaPoliciesPolicyNumberRouteImport } from './routes/rema/policies/$policyNumber'
import { Route as RemaGroupsAddRouteImport } from './routes/rema/groups/add'
import { Route as RemaGroupsGroupNumberRouteImport } from './routes/rema/groups/$groupNumber'
import { Route as OrganizationsOrganizationNumberEditRouteImport } from './routes/organizations/$organizationNumber_.edit'
import { Route as SensoryManufacturersManufacturerNumberEditRouteImport } from './routes/sensory/manufacturers/$manufacturerNumber_.edit'
import { Route as SensoryDistributorsDistributorNumberEditRouteImport } from './routes/sensory/distributors/$distributorNumber_.edit'
import { Route as SensoryDevicesDeviceNumberEditRouteImport } from './routes/sensory/devices/$deviceNumber_.edit'
import { Route as SensoryDeviceTypesDeviceTypeNumberEditRouteImport } from './routes/sensory/device-types/$deviceTypeNumber_.edit'
import { Route as SensoryDeviceProfilesDeviceProfileNumberEditRouteImport } from './routes/sensory/device-profiles/$deviceProfileNumber_.edit'
import { Route as SensnetSensingStationsStationNumberEditRouteImport } from './routes/sensnet/sensing-stations/$stationNumber_.edit'
import { Route as SensnetNetworkSitesNetworkSiteNumberEditRouteImport } from './routes/sensnet/network-sites/$networkSiteNumber_.edit'
import { Route as SensnetNetworkCorridorsNetworkCorridorNumberEditRouteImport } from './routes/sensnet/network-corridors/$networkCorridorNumber_.edit'
import { Route as RemaRolesRoleNumberEditRouteImport } from './routes/rema/roles/$roleNumber_.edit'
import { Route as RemaResourceTypesResourceTypeNumberEditRouteImport } from './routes/rema/resource-types/$resourceTypeNumber_.edit'
import { Route as RemaResourceInstancesInstanceNumberEditRouteImport } from './routes/rema/resource-instances/$instanceNumber_.edit'
import { Route as RemaPoliciesPolicyNumberEditRouteImport } from './routes/rema/policies/$policyNumber_.edit'
import { Route as RemaGroupsGroupNumberEditRouteImport } from './routes/rema/groups/$groupNumber_.edit'

const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const RootRoute = RootRouteImport.update({
  id: '/root',
  path: '/root',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRedirectRoute = AuthRedirectRouteImport.update({
  id: '/auth-redirect',
  path: '/auth-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiDocsRoute = ApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => rootRouteImport,
} as any)
const FrameRoute = FrameRouteImport.update({
  id: '/_frame',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsIndexRoute = InvitationsIndexRouteImport.update({
  id: '/invitations/',
  path: '/invitations/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationTypesIndexRoute = InvitationTypesIndexRouteImport.update({
  id: '/invitation-types/',
  path: '/invitation-types/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiDocsIndexRoute = ApiDocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApiDocsRoute,
} as any)
const LayoutSensoryRoute = LayoutSensoryRouteImport.update({
  id: '/layout/sensory',
  path: '/layout/sensory',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutFrameRoute = LayoutFrameRouteImport.update({
  id: '/layout/frame',
  path: '/layout/frame',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiDocsFarmgridRoute = ApiDocsFarmgridRouteImport.update({
  id: '/farmgrid',
  path: '/farmgrid',
  getParentRoute: () => ApiDocsRoute,
} as any)
const ApiDocsConexRoute = ApiDocsConexRouteImport.update({
  id: '/conex',
  path: '/conex',
  getParentRoute: () => ApiDocsRoute,
} as any)
const UsersUserNumberIndexRoute = UsersUserNumberIndexRouteImport.update({
  id: '/users/$userNumber/',
  path: '/users/$userNumber/',
  getParentRoute: () => rootRouteImport,
} as any)
const SensoryManufacturersIndexRoute =
  SensoryManufacturersIndexRouteImport.update({
    id: '/sensory/manufacturers/',
    path: '/sensory/manufacturers/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDistributorsIndexRoute =
  SensoryDistributorsIndexRouteImport.update({
    id: '/sensory/distributors/',
    path: '/sensory/distributors/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDevicesIndexRoute = SensoryDevicesIndexRouteImport.update({
  id: '/sensory/devices/',
  path: '/sensory/devices/',
  getParentRoute: () => rootRouteImport,
} as any)
const SensoryDeviceTypesIndexRoute = SensoryDeviceTypesIndexRouteImport.update({
  id: '/sensory/device-types/',
  path: '/sensory/device-types/',
  getParentRoute: () => rootRouteImport,
} as any)
const SensoryDeviceProfilesIndexRoute =
  SensoryDeviceProfilesIndexRouteImport.update({
    id: '/sensory/device-profiles/',
    path: '/sensory/device-profiles/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDeviceManagementIndexRoute =
  SensoryDeviceManagementIndexRouteImport.update({
    id: '/sensory/device-management/',
    path: '/sensory/device-management/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetSensingStationsIndexRoute =
  SensnetSensingStationsIndexRouteImport.update({
    id: '/sensnet/sensing-stations/',
    path: '/sensnet/sensing-stations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetNetworkSitesIndexRoute =
  SensnetNetworkSitesIndexRouteImport.update({
    id: '/sensnet/network-sites/',
    path: '/sensnet/network-sites/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetNetworkCorridorsIndexRoute =
  SensnetNetworkCorridorsIndexRouteImport.update({
    id: '/sensnet/network-corridors/',
    path: '/sensnet/network-corridors/',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaRolesIndexRoute = RemaRolesIndexRouteImport.update({
  id: '/rema/roles/',
  path: '/rema/roles/',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaResourceTypesIndexRoute = RemaResourceTypesIndexRouteImport.update({
  id: '/rema/resource-types/',
  path: '/rema/resource-types/',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaResourceInstancesIndexRoute =
  RemaResourceInstancesIndexRouteImport.update({
    id: '/rema/resource-instances/',
    path: '/rema/resource-instances/',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaPoliciesIndexRoute = RemaPoliciesIndexRouteImport.update({
  id: '/rema/policies/',
  path: '/rema/policies/',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaGroupsIndexRoute = RemaGroupsIndexRouteImport.update({
  id: '/rema/groups/',
  path: '/rema/groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaControlPlaneResourceInstancesIndexRoute =
  RemaControlPlaneResourceInstancesIndexRouteImport.update({
    id: '/rema/control-plane-resource-instances/',
    path: '/rema/control-plane-resource-instances/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationsOrganizationNumberIndexRoute =
  OrganizationsOrganizationNumberIndexRouteImport.update({
    id: '/organizations/$organizationNumber/',
    path: '/organizations/$organizationNumber/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EventsEventTypesIndexRoute = EventsEventTypesIndexRouteImport.update({
  id: '/events/event-types/',
  path: '/events/event-types/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEntityTypesIndexRoute = EventsEntityTypesIndexRouteImport.update({
  id: '/events/entity-types/',
  path: '/events/entity-types/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsActionsIndexRoute = EventsActionsIndexRouteImport.update({
  id: '/events/actions/',
  path: '/events/actions/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserNumberEditRoute = UsersUserNumberEditRouteImport.update({
  id: '/users/$userNumber_/edit',
  path: '/users/$userNumber/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const SensoryManufacturersManufacturerNumberRoute =
  SensoryManufacturersManufacturerNumberRouteImport.update({
    id: '/sensory/manufacturers/$manufacturerNumber',
    path: '/sensory/manufacturers/$manufacturerNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDistributorsDistributorNumberRoute =
  SensoryDistributorsDistributorNumberRouteImport.update({
    id: '/sensory/distributors/$distributorNumber',
    path: '/sensory/distributors/$distributorNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDevicesDeviceNumberRoute =
  SensoryDevicesDeviceNumberRouteImport.update({
    id: '/sensory/devices/$deviceNumber',
    path: '/sensory/devices/$deviceNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDeviceTypesDeviceTypeNumberRoute =
  SensoryDeviceTypesDeviceTypeNumberRouteImport.update({
    id: '/sensory/device-types/$deviceTypeNumber',
    path: '/sensory/device-types/$deviceTypeNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDeviceProfilesDeviceProfileNumberRoute =
  SensoryDeviceProfilesDeviceProfileNumberRouteImport.update({
    id: '/sensory/device-profiles/$deviceProfileNumber',
    path: '/sensory/device-profiles/$deviceProfileNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetSensingStationsStationNumberRoute =
  SensnetSensingStationsStationNumberRouteImport.update({
    id: '/sensnet/sensing-stations/$stationNumber',
    path: '/sensnet/sensing-stations/$stationNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetNetworkSitesSiteNumberRoute =
  SensnetNetworkSitesSiteNumberRouteImport.update({
    id: '/sensnet/network-sites/$siteNumber',
    path: '/sensnet/network-sites/$siteNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetNetworkCorridorsCorridorNumberRoute =
  SensnetNetworkCorridorsCorridorNumberRouteImport.update({
    id: '/sensnet/network-corridors/$corridorNumber',
    path: '/sensnet/network-corridors/$corridorNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaRolesAddRoute = RemaRolesAddRouteImport.update({
  id: '/rema/roles/add',
  path: '/rema/roles/add',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaRolesRoleNumberRoute = RemaRolesRoleNumberRouteImport.update({
  id: '/rema/roles/$roleNumber',
  path: '/rema/roles/$roleNumber',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaResourceTypesAddRoute = RemaResourceTypesAddRouteImport.update({
  id: '/rema/resource-types/add',
  path: '/rema/resource-types/add',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaResourceTypesResourceTypeNumberRoute =
  RemaResourceTypesResourceTypeNumberRouteImport.update({
    id: '/rema/resource-types/$resourceTypeNumber',
    path: '/rema/resource-types/$resourceTypeNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaResourceInstancesAddRoute =
  RemaResourceInstancesAddRouteImport.update({
    id: '/rema/resource-instances/add',
    path: '/rema/resource-instances/add',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaResourceInstancesInstanceNumberRoute =
  RemaResourceInstancesInstanceNumberRouteImport.update({
    id: '/rema/resource-instances/$instanceNumber',
    path: '/rema/resource-instances/$instanceNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaPoliciesAddRoute = RemaPoliciesAddRouteImport.update({
  id: '/rema/policies/add',
  path: '/rema/policies/add',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaPoliciesPolicyNumberRoute =
  RemaPoliciesPolicyNumberRouteImport.update({
    id: '/rema/policies/$policyNumber',
    path: '/rema/policies/$policyNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaGroupsAddRoute = RemaGroupsAddRouteImport.update({
  id: '/rema/groups/add',
  path: '/rema/groups/add',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaGroupsGroupNumberRoute = RemaGroupsGroupNumberRouteImport.update({
  id: '/rema/groups/$groupNumber',
  path: '/rema/groups/$groupNumber',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsOrganizationNumberEditRoute =
  OrganizationsOrganizationNumberEditRouteImport.update({
    id: '/organizations/$organizationNumber_/edit',
    path: '/organizations/$organizationNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryManufacturersManufacturerNumberEditRoute =
  SensoryManufacturersManufacturerNumberEditRouteImport.update({
    id: '/sensory/manufacturers/$manufacturerNumber_/edit',
    path: '/sensory/manufacturers/$manufacturerNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDistributorsDistributorNumberEditRoute =
  SensoryDistributorsDistributorNumberEditRouteImport.update({
    id: '/sensory/distributors/$distributorNumber_/edit',
    path: '/sensory/distributors/$distributorNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDevicesDeviceNumberEditRoute =
  SensoryDevicesDeviceNumberEditRouteImport.update({
    id: '/sensory/devices/$deviceNumber_/edit',
    path: '/sensory/devices/$deviceNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDeviceTypesDeviceTypeNumberEditRoute =
  SensoryDeviceTypesDeviceTypeNumberEditRouteImport.update({
    id: '/sensory/device-types/$deviceTypeNumber_/edit',
    path: '/sensory/device-types/$deviceTypeNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensoryDeviceProfilesDeviceProfileNumberEditRoute =
  SensoryDeviceProfilesDeviceProfileNumberEditRouteImport.update({
    id: '/sensory/device-profiles/$deviceProfileNumber_/edit',
    path: '/sensory/device-profiles/$deviceProfileNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetSensingStationsStationNumberEditRoute =
  SensnetSensingStationsStationNumberEditRouteImport.update({
    id: '/sensnet/sensing-stations/$stationNumber_/edit',
    path: '/sensnet/sensing-stations/$stationNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetNetworkSitesNetworkSiteNumberEditRoute =
  SensnetNetworkSitesNetworkSiteNumberEditRouteImport.update({
    id: '/sensnet/network-sites/$networkSiteNumber_/edit',
    path: '/sensnet/network-sites/$networkSiteNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensnetNetworkCorridorsNetworkCorridorNumberEditRoute =
  SensnetNetworkCorridorsNetworkCorridorNumberEditRouteImport.update({
    id: '/sensnet/network-corridors/$networkCorridorNumber_/edit',
    path: '/sensnet/network-corridors/$networkCorridorNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaRolesRoleNumberEditRoute = RemaRolesRoleNumberEditRouteImport.update({
  id: '/rema/roles/$roleNumber_/edit',
  path: '/rema/roles/$roleNumber/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const RemaResourceTypesResourceTypeNumberEditRoute =
  RemaResourceTypesResourceTypeNumberEditRouteImport.update({
    id: '/rema/resource-types/$resourceTypeNumber_/edit',
    path: '/rema/resource-types/$resourceTypeNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaResourceInstancesInstanceNumberEditRoute =
  RemaResourceInstancesInstanceNumberEditRouteImport.update({
    id: '/rema/resource-instances/$instanceNumber_/edit',
    path: '/rema/resource-instances/$instanceNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaPoliciesPolicyNumberEditRoute =
  RemaPoliciesPolicyNumberEditRouteImport.update({
    id: '/rema/policies/$policyNumber_/edit',
    path: '/rema/policies/$policyNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const RemaGroupsGroupNumberEditRoute =
  RemaGroupsGroupNumberEditRouteImport.update({
    id: '/rema/groups/$groupNumber_/edit',
    path: '/rema/groups/$groupNumber/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/api-docs': typeof ApiDocsRouteWithChildren
  '/auth-redirect': typeof AuthRedirectRoute
  '/home': typeof HomeRoute
  '/root': typeof RootRoute
  '/signin': typeof SigninRoute
  '/api-docs/conex': typeof ApiDocsConexRoute
  '/api-docs/farmgrid': typeof ApiDocsFarmgridRoute
  '/layout/frame': typeof LayoutFrameRoute
  '/layout/sensory': typeof LayoutSensoryRoute
  '/api-docs/': typeof ApiDocsIndexRoute
  '/invitation-types': typeof InvitationTypesIndexRoute
  '/invitations': typeof InvitationsIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/users': typeof UsersIndexRoute
  '/organizations/$organizationNumber/edit': typeof OrganizationsOrganizationNumberEditRoute
  '/rema/groups/$groupNumber': typeof RemaGroupsGroupNumberRoute
  '/rema/groups/add': typeof RemaGroupsAddRoute
  '/rema/policies/$policyNumber': typeof RemaPoliciesPolicyNumberRoute
  '/rema/policies/add': typeof RemaPoliciesAddRoute
  '/rema/resource-instances/$instanceNumber': typeof RemaResourceInstancesInstanceNumberRoute
  '/rema/resource-instances/add': typeof RemaResourceInstancesAddRoute
  '/rema/resource-types/$resourceTypeNumber': typeof RemaResourceTypesResourceTypeNumberRoute
  '/rema/resource-types/add': typeof RemaResourceTypesAddRoute
  '/rema/roles/$roleNumber': typeof RemaRolesRoleNumberRoute
  '/rema/roles/add': typeof RemaRolesAddRoute
  '/sensnet/network-corridors/$corridorNumber': typeof SensnetNetworkCorridorsCorridorNumberRoute
  '/sensnet/network-sites/$siteNumber': typeof SensnetNetworkSitesSiteNumberRoute
  '/sensnet/sensing-stations/$stationNumber': typeof SensnetSensingStationsStationNumberRoute
  '/sensory/device-profiles/$deviceProfileNumber': typeof SensoryDeviceProfilesDeviceProfileNumberRoute
  '/sensory/device-types/$deviceTypeNumber': typeof SensoryDeviceTypesDeviceTypeNumberRoute
  '/sensory/devices/$deviceNumber': typeof SensoryDevicesDeviceNumberRoute
  '/sensory/distributors/$distributorNumber': typeof SensoryDistributorsDistributorNumberRoute
  '/sensory/manufacturers/$manufacturerNumber': typeof SensoryManufacturersManufacturerNumberRoute
  '/users/$userNumber/edit': typeof UsersUserNumberEditRoute
  '/events/actions': typeof EventsActionsIndexRoute
  '/events/entity-types': typeof EventsEntityTypesIndexRoute
  '/events/event-types': typeof EventsEventTypesIndexRoute
  '/organizations/$organizationNumber': typeof OrganizationsOrganizationNumberIndexRoute
  '/rema/control-plane-resource-instances': typeof RemaControlPlaneResourceInstancesIndexRoute
  '/rema/groups': typeof RemaGroupsIndexRoute
  '/rema/policies': typeof RemaPoliciesIndexRoute
  '/rema/resource-instances': typeof RemaResourceInstancesIndexRoute
  '/rema/resource-types': typeof RemaResourceTypesIndexRoute
  '/rema/roles': typeof RemaRolesIndexRoute
  '/sensnet/network-corridors': typeof SensnetNetworkCorridorsIndexRoute
  '/sensnet/network-sites': typeof SensnetNetworkSitesIndexRoute
  '/sensnet/sensing-stations': typeof SensnetSensingStationsIndexRoute
  '/sensory/device-management': typeof SensoryDeviceManagementIndexRoute
  '/sensory/device-profiles': typeof SensoryDeviceProfilesIndexRoute
  '/sensory/device-types': typeof SensoryDeviceTypesIndexRoute
  '/sensory/devices': typeof SensoryDevicesIndexRoute
  '/sensory/distributors': typeof SensoryDistributorsIndexRoute
  '/sensory/manufacturers': typeof SensoryManufacturersIndexRoute
  '/users/$userNumber': typeof UsersUserNumberIndexRoute
  '/rema/groups/$groupNumber/edit': typeof RemaGroupsGroupNumberEditRoute
  '/rema/policies/$policyNumber/edit': typeof RemaPoliciesPolicyNumberEditRoute
  '/rema/resource-instances/$instanceNumber/edit': typeof RemaResourceInstancesInstanceNumberEditRoute
  '/rema/resource-types/$resourceTypeNumber/edit': typeof RemaResourceTypesResourceTypeNumberEditRoute
  '/rema/roles/$roleNumber/edit': typeof RemaRolesRoleNumberEditRoute
  '/sensnet/network-corridors/$networkCorridorNumber/edit': typeof SensnetNetworkCorridorsNetworkCorridorNumberEditRoute
  '/sensnet/network-sites/$networkSiteNumber/edit': typeof SensnetNetworkSitesNetworkSiteNumberEditRoute
  '/sensnet/sensing-stations/$stationNumber/edit': typeof SensnetSensingStationsStationNumberEditRoute
  '/sensory/device-profiles/$deviceProfileNumber/edit': typeof SensoryDeviceProfilesDeviceProfileNumberEditRoute
  '/sensory/device-types/$deviceTypeNumber/edit': typeof SensoryDeviceTypesDeviceTypeNumberEditRoute
  '/sensory/devices/$deviceNumber/edit': typeof SensoryDevicesDeviceNumberEditRoute
  '/sensory/distributors/$distributorNumber/edit': typeof SensoryDistributorsDistributorNumberEditRoute
  '/sensory/manufacturers/$manufacturerNumber/edit': typeof SensoryManufacturersManufacturerNumberEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-redirect': typeof AuthRedirectRoute
  '/home': typeof HomeRoute
  '/root': typeof RootRoute
  '/signin': typeof SigninRoute
  '/api-docs/conex': typeof ApiDocsConexRoute
  '/api-docs/farmgrid': typeof ApiDocsFarmgridRoute
  '/layout/frame': typeof LayoutFrameRoute
  '/layout/sensory': typeof LayoutSensoryRoute
  '/api-docs': typeof ApiDocsIndexRoute
  '/invitation-types': typeof InvitationTypesIndexRoute
  '/invitations': typeof InvitationsIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/users': typeof UsersIndexRoute
  '/organizations/$organizationNumber/edit': typeof OrganizationsOrganizationNumberEditRoute
  '/rema/groups/$groupNumber': typeof RemaGroupsGroupNumberRoute
  '/rema/groups/add': typeof RemaGroupsAddRoute
  '/rema/policies/$policyNumber': typeof RemaPoliciesPolicyNumberRoute
  '/rema/policies/add': typeof RemaPoliciesAddRoute
  '/rema/resource-instances/$instanceNumber': typeof RemaResourceInstancesInstanceNumberRoute
  '/rema/resource-instances/add': typeof RemaResourceInstancesAddRoute
  '/rema/resource-types/$resourceTypeNumber': typeof RemaResourceTypesResourceTypeNumberRoute
  '/rema/resource-types/add': typeof RemaResourceTypesAddRoute
  '/rema/roles/$roleNumber': typeof RemaRolesRoleNumberRoute
  '/rema/roles/add': typeof RemaRolesAddRoute
  '/sensnet/network-corridors/$corridorNumber': typeof SensnetNetworkCorridorsCorridorNumberRoute
  '/sensnet/network-sites/$siteNumber': typeof SensnetNetworkSitesSiteNumberRoute
  '/sensnet/sensing-stations/$stationNumber': typeof SensnetSensingStationsStationNumberRoute
  '/sensory/device-profiles/$deviceProfileNumber': typeof SensoryDeviceProfilesDeviceProfileNumberRoute
  '/sensory/device-types/$deviceTypeNumber': typeof SensoryDeviceTypesDeviceTypeNumberRoute
  '/sensory/devices/$deviceNumber': typeof SensoryDevicesDeviceNumberRoute
  '/sensory/distributors/$distributorNumber': typeof SensoryDistributorsDistributorNumberRoute
  '/sensory/manufacturers/$manufacturerNumber': typeof SensoryManufacturersManufacturerNumberRoute
  '/users/$userNumber/edit': typeof UsersUserNumberEditRoute
  '/events/actions': typeof EventsActionsIndexRoute
  '/events/entity-types': typeof EventsEntityTypesIndexRoute
  '/events/event-types': typeof EventsEventTypesIndexRoute
  '/organizations/$organizationNumber': typeof OrganizationsOrganizationNumberIndexRoute
  '/rema/control-plane-resource-instances': typeof RemaControlPlaneResourceInstancesIndexRoute
  '/rema/groups': typeof RemaGroupsIndexRoute
  '/rema/policies': typeof RemaPoliciesIndexRoute
  '/rema/resource-instances': typeof RemaResourceInstancesIndexRoute
  '/rema/resource-types': typeof RemaResourceTypesIndexRoute
  '/rema/roles': typeof RemaRolesIndexRoute
  '/sensnet/network-corridors': typeof SensnetNetworkCorridorsIndexRoute
  '/sensnet/network-sites': typeof SensnetNetworkSitesIndexRoute
  '/sensnet/sensing-stations': typeof SensnetSensingStationsIndexRoute
  '/sensory/device-management': typeof SensoryDeviceManagementIndexRoute
  '/sensory/device-profiles': typeof SensoryDeviceProfilesIndexRoute
  '/sensory/device-types': typeof SensoryDeviceTypesIndexRoute
  '/sensory/devices': typeof SensoryDevicesIndexRoute
  '/sensory/distributors': typeof SensoryDistributorsIndexRoute
  '/sensory/manufacturers': typeof SensoryManufacturersIndexRoute
  '/users/$userNumber': typeof UsersUserNumberIndexRoute
  '/rema/groups/$groupNumber/edit': typeof RemaGroupsGroupNumberEditRoute
  '/rema/policies/$policyNumber/edit': typeof RemaPoliciesPolicyNumberEditRoute
  '/rema/resource-instances/$instanceNumber/edit': typeof RemaResourceInstancesInstanceNumberEditRoute
  '/rema/resource-types/$resourceTypeNumber/edit': typeof RemaResourceTypesResourceTypeNumberEditRoute
  '/rema/roles/$roleNumber/edit': typeof RemaRolesRoleNumberEditRoute
  '/sensnet/network-corridors/$networkCorridorNumber/edit': typeof SensnetNetworkCorridorsNetworkCorridorNumberEditRoute
  '/sensnet/network-sites/$networkSiteNumber/edit': typeof SensnetNetworkSitesNetworkSiteNumberEditRoute
  '/sensnet/sensing-stations/$stationNumber/edit': typeof SensnetSensingStationsStationNumberEditRoute
  '/sensory/device-profiles/$deviceProfileNumber/edit': typeof SensoryDeviceProfilesDeviceProfileNumberEditRoute
  '/sensory/device-types/$deviceTypeNumber/edit': typeof SensoryDeviceTypesDeviceTypeNumberEditRoute
  '/sensory/devices/$deviceNumber/edit': typeof SensoryDevicesDeviceNumberEditRoute
  '/sensory/distributors/$distributorNumber/edit': typeof SensoryDistributorsDistributorNumberEditRoute
  '/sensory/manufacturers/$manufacturerNumber/edit': typeof SensoryManufacturersManufacturerNumberEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_frame': typeof FrameRoute
  '/api-docs': typeof ApiDocsRouteWithChildren
  '/auth-redirect': typeof AuthRedirectRoute
  '/home': typeof HomeRoute
  '/root': typeof RootRoute
  '/signin': typeof SigninRoute
  '/api-docs/conex': typeof ApiDocsConexRoute
  '/api-docs/farmgrid': typeof ApiDocsFarmgridRoute
  '/layout/frame': typeof LayoutFrameRoute
  '/layout/sensory': typeof LayoutSensoryRoute
  '/api-docs/': typeof ApiDocsIndexRoute
  '/invitation-types/': typeof InvitationTypesIndexRoute
  '/invitations/': typeof InvitationsIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/organizations/$organizationNumber_/edit': typeof OrganizationsOrganizationNumberEditRoute
  '/rema/groups/$groupNumber': typeof RemaGroupsGroupNumberRoute
  '/rema/groups/add': typeof RemaGroupsAddRoute
  '/rema/policies/$policyNumber': typeof RemaPoliciesPolicyNumberRoute
  '/rema/policies/add': typeof RemaPoliciesAddRoute
  '/rema/resource-instances/$instanceNumber': typeof RemaResourceInstancesInstanceNumberRoute
  '/rema/resource-instances/add': typeof RemaResourceInstancesAddRoute
  '/rema/resource-types/$resourceTypeNumber': typeof RemaResourceTypesResourceTypeNumberRoute
  '/rema/resource-types/add': typeof RemaResourceTypesAddRoute
  '/rema/roles/$roleNumber': typeof RemaRolesRoleNumberRoute
  '/rema/roles/add': typeof RemaRolesAddRoute
  '/sensnet/network-corridors/$corridorNumber': typeof SensnetNetworkCorridorsCorridorNumberRoute
  '/sensnet/network-sites/$siteNumber': typeof SensnetNetworkSitesSiteNumberRoute
  '/sensnet/sensing-stations/$stationNumber': typeof SensnetSensingStationsStationNumberRoute
  '/sensory/device-profiles/$deviceProfileNumber': typeof SensoryDeviceProfilesDeviceProfileNumberRoute
  '/sensory/device-types/$deviceTypeNumber': typeof SensoryDeviceTypesDeviceTypeNumberRoute
  '/sensory/devices/$deviceNumber': typeof SensoryDevicesDeviceNumberRoute
  '/sensory/distributors/$distributorNumber': typeof SensoryDistributorsDistributorNumberRoute
  '/sensory/manufacturers/$manufacturerNumber': typeof SensoryManufacturersManufacturerNumberRoute
  '/users/$userNumber_/edit': typeof UsersUserNumberEditRoute
  '/events/actions/': typeof EventsActionsIndexRoute
  '/events/entity-types/': typeof EventsEntityTypesIndexRoute
  '/events/event-types/': typeof EventsEventTypesIndexRoute
  '/organizations/$organizationNumber/': typeof OrganizationsOrganizationNumberIndexRoute
  '/rema/control-plane-resource-instances/': typeof RemaControlPlaneResourceInstancesIndexRoute
  '/rema/groups/': typeof RemaGroupsIndexRoute
  '/rema/policies/': typeof RemaPoliciesIndexRoute
  '/rema/resource-instances/': typeof RemaResourceInstancesIndexRoute
  '/rema/resource-types/': typeof RemaResourceTypesIndexRoute
  '/rema/roles/': typeof RemaRolesIndexRoute
  '/sensnet/network-corridors/': typeof SensnetNetworkCorridorsIndexRoute
  '/sensnet/network-sites/': typeof SensnetNetworkSitesIndexRoute
  '/sensnet/sensing-stations/': typeof SensnetSensingStationsIndexRoute
  '/sensory/device-management/': typeof SensoryDeviceManagementIndexRoute
  '/sensory/device-profiles/': typeof SensoryDeviceProfilesIndexRoute
  '/sensory/device-types/': typeof SensoryDeviceTypesIndexRoute
  '/sensory/devices/': typeof SensoryDevicesIndexRoute
  '/sensory/distributors/': typeof SensoryDistributorsIndexRoute
  '/sensory/manufacturers/': typeof SensoryManufacturersIndexRoute
  '/users/$userNumber/': typeof UsersUserNumberIndexRoute
  '/rema/groups/$groupNumber_/edit': typeof RemaGroupsGroupNumberEditRoute
  '/rema/policies/$policyNumber_/edit': typeof RemaPoliciesPolicyNumberEditRoute
  '/rema/resource-instances/$instanceNumber_/edit': typeof RemaResourceInstancesInstanceNumberEditRoute
  '/rema/resource-types/$resourceTypeNumber_/edit': typeof RemaResourceTypesResourceTypeNumberEditRoute
  '/rema/roles/$roleNumber_/edit': typeof RemaRolesRoleNumberEditRoute
  '/sensnet/network-corridors/$networkCorridorNumber_/edit': typeof SensnetNetworkCorridorsNetworkCorridorNumberEditRoute
  '/sensnet/network-sites/$networkSiteNumber_/edit': typeof SensnetNetworkSitesNetworkSiteNumberEditRoute
  '/sensnet/sensing-stations/$stationNumber_/edit': typeof SensnetSensingStationsStationNumberEditRoute
  '/sensory/device-profiles/$deviceProfileNumber_/edit': typeof SensoryDeviceProfilesDeviceProfileNumberEditRoute
  '/sensory/device-types/$deviceTypeNumber_/edit': typeof SensoryDeviceTypesDeviceTypeNumberEditRoute
  '/sensory/devices/$deviceNumber_/edit': typeof SensoryDevicesDeviceNumberEditRoute
  '/sensory/distributors/$distributorNumber_/edit': typeof SensoryDistributorsDistributorNumberEditRoute
  '/sensory/manufacturers/$manufacturerNumber_/edit': typeof SensoryManufacturersManufacturerNumberEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/api-docs'
    | '/auth-redirect'
    | '/home'
    | '/root'
    | '/signin'
    | '/api-docs/conex'
    | '/api-docs/farmgrid'
    | '/layout/frame'
    | '/layout/sensory'
    | '/api-docs/'
    | '/invitation-types'
    | '/invitations'
    | '/organizations'
    | '/users'
    | '/organizations/$organizationNumber/edit'
    | '/rema/groups/$groupNumber'
    | '/rema/groups/add'
    | '/rema/policies/$policyNumber'
    | '/rema/policies/add'
    | '/rema/resource-instances/$instanceNumber'
    | '/rema/resource-instances/add'
    | '/rema/resource-types/$resourceTypeNumber'
    | '/rema/resource-types/add'
    | '/rema/roles/$roleNumber'
    | '/rema/roles/add'
    | '/sensnet/network-corridors/$corridorNumber'
    | '/sensnet/network-sites/$siteNumber'
    | '/sensnet/sensing-stations/$stationNumber'
    | '/sensory/device-profiles/$deviceProfileNumber'
    | '/sensory/device-types/$deviceTypeNumber'
    | '/sensory/devices/$deviceNumber'
    | '/sensory/distributors/$distributorNumber'
    | '/sensory/manufacturers/$manufacturerNumber'
    | '/users/$userNumber/edit'
    | '/events/actions'
    | '/events/entity-types'
    | '/events/event-types'
    | '/organizations/$organizationNumber'
    | '/rema/control-plane-resource-instances'
    | '/rema/groups'
    | '/rema/policies'
    | '/rema/resource-instances'
    | '/rema/resource-types'
    | '/rema/roles'
    | '/sensnet/network-corridors'
    | '/sensnet/network-sites'
    | '/sensnet/sensing-stations'
    | '/sensory/device-management'
    | '/sensory/device-profiles'
    | '/sensory/device-types'
    | '/sensory/devices'
    | '/sensory/distributors'
    | '/sensory/manufacturers'
    | '/users/$userNumber'
    | '/rema/groups/$groupNumber/edit'
    | '/rema/policies/$policyNumber/edit'
    | '/rema/resource-instances/$instanceNumber/edit'
    | '/rema/resource-types/$resourceTypeNumber/edit'
    | '/rema/roles/$roleNumber/edit'
    | '/sensnet/network-corridors/$networkCorridorNumber/edit'
    | '/sensnet/network-sites/$networkSiteNumber/edit'
    | '/sensnet/sensing-stations/$stationNumber/edit'
    | '/sensory/device-profiles/$deviceProfileNumber/edit'
    | '/sensory/device-types/$deviceTypeNumber/edit'
    | '/sensory/devices/$deviceNumber/edit'
    | '/sensory/distributors/$distributorNumber/edit'
    | '/sensory/manufacturers/$manufacturerNumber/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-redirect'
    | '/home'
    | '/root'
    | '/signin'
    | '/api-docs/conex'
    | '/api-docs/farmgrid'
    | '/layout/frame'
    | '/layout/sensory'
    | '/api-docs'
    | '/invitation-types'
    | '/invitations'
    | '/organizations'
    | '/users'
    | '/organizations/$organizationNumber/edit'
    | '/rema/groups/$groupNumber'
    | '/rema/groups/add'
    | '/rema/policies/$policyNumber'
    | '/rema/policies/add'
    | '/rema/resource-instances/$instanceNumber'
    | '/rema/resource-instances/add'
    | '/rema/resource-types/$resourceTypeNumber'
    | '/rema/resource-types/add'
    | '/rema/roles/$roleNumber'
    | '/rema/roles/add'
    | '/sensnet/network-corridors/$corridorNumber'
    | '/sensnet/network-sites/$siteNumber'
    | '/sensnet/sensing-stations/$stationNumber'
    | '/sensory/device-profiles/$deviceProfileNumber'
    | '/sensory/device-types/$deviceTypeNumber'
    | '/sensory/devices/$deviceNumber'
    | '/sensory/distributors/$distributorNumber'
    | '/sensory/manufacturers/$manufacturerNumber'
    | '/users/$userNumber/edit'
    | '/events/actions'
    | '/events/entity-types'
    | '/events/event-types'
    | '/organizations/$organizationNumber'
    | '/rema/control-plane-resource-instances'
    | '/rema/groups'
    | '/rema/policies'
    | '/rema/resource-instances'
    | '/rema/resource-types'
    | '/rema/roles'
    | '/sensnet/network-corridors'
    | '/sensnet/network-sites'
    | '/sensnet/sensing-stations'
    | '/sensory/device-management'
    | '/sensory/device-profiles'
    | '/sensory/device-types'
    | '/sensory/devices'
    | '/sensory/distributors'
    | '/sensory/manufacturers'
    | '/users/$userNumber'
    | '/rema/groups/$groupNumber/edit'
    | '/rema/policies/$policyNumber/edit'
    | '/rema/resource-instances/$instanceNumber/edit'
    | '/rema/resource-types/$resourceTypeNumber/edit'
    | '/rema/roles/$roleNumber/edit'
    | '/sensnet/network-corridors/$networkCorridorNumber/edit'
    | '/sensnet/network-sites/$networkSiteNumber/edit'
    | '/sensnet/sensing-stations/$stationNumber/edit'
    | '/sensory/device-profiles/$deviceProfileNumber/edit'
    | '/sensory/device-types/$deviceTypeNumber/edit'
    | '/sensory/devices/$deviceNumber/edit'
    | '/sensory/distributors/$distributorNumber/edit'
    | '/sensory/manufacturers/$manufacturerNumber/edit'
  id:
    | '__root__'
    | '/'
    | '/_frame'
    | '/api-docs'
    | '/auth-redirect'
    | '/home'
    | '/root'
    | '/signin'
    | '/api-docs/conex'
    | '/api-docs/farmgrid'
    | '/layout/frame'
    | '/layout/sensory'
    | '/api-docs/'
    | '/invitation-types/'
    | '/invitations/'
    | '/organizations/'
    | '/users/'
    | '/organizations/$organizationNumber_/edit'
    | '/rema/groups/$groupNumber'
    | '/rema/groups/add'
    | '/rema/policies/$policyNumber'
    | '/rema/policies/add'
    | '/rema/resource-instances/$instanceNumber'
    | '/rema/resource-instances/add'
    | '/rema/resource-types/$resourceTypeNumber'
    | '/rema/resource-types/add'
    | '/rema/roles/$roleNumber'
    | '/rema/roles/add'
    | '/sensnet/network-corridors/$corridorNumber'
    | '/sensnet/network-sites/$siteNumber'
    | '/sensnet/sensing-stations/$stationNumber'
    | '/sensory/device-profiles/$deviceProfileNumber'
    | '/sensory/device-types/$deviceTypeNumber'
    | '/sensory/devices/$deviceNumber'
    | '/sensory/distributors/$distributorNumber'
    | '/sensory/manufacturers/$manufacturerNumber'
    | '/users/$userNumber_/edit'
    | '/events/actions/'
    | '/events/entity-types/'
    | '/events/event-types/'
    | '/organizations/$organizationNumber/'
    | '/rema/control-plane-resource-instances/'
    | '/rema/groups/'
    | '/rema/policies/'
    | '/rema/resource-instances/'
    | '/rema/resource-types/'
    | '/rema/roles/'
    | '/sensnet/network-corridors/'
    | '/sensnet/network-sites/'
    | '/sensnet/sensing-stations/'
    | '/sensory/device-management/'
    | '/sensory/device-profiles/'
    | '/sensory/device-types/'
    | '/sensory/devices/'
    | '/sensory/distributors/'
    | '/sensory/manufacturers/'
    | '/users/$userNumber/'
    | '/rema/groups/$groupNumber_/edit'
    | '/rema/policies/$policyNumber_/edit'
    | '/rema/resource-instances/$instanceNumber_/edit'
    | '/rema/resource-types/$resourceTypeNumber_/edit'
    | '/rema/roles/$roleNumber_/edit'
    | '/sensnet/network-corridors/$networkCorridorNumber_/edit'
    | '/sensnet/network-sites/$networkSiteNumber_/edit'
    | '/sensnet/sensing-stations/$stationNumber_/edit'
    | '/sensory/device-profiles/$deviceProfileNumber_/edit'
    | '/sensory/device-types/$deviceTypeNumber_/edit'
    | '/sensory/devices/$deviceNumber_/edit'
    | '/sensory/distributors/$distributorNumber_/edit'
    | '/sensory/manufacturers/$manufacturerNumber_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FrameRoute: typeof FrameRoute
  ApiDocsRoute: typeof ApiDocsRouteWithChildren
  AuthRedirectRoute: typeof AuthRedirectRoute
  HomeRoute: typeof HomeRoute
  RootRoute: typeof RootRoute
  SigninRoute: typeof SigninRoute
  LayoutFrameRoute: typeof LayoutFrameRoute
  LayoutSensoryRoute: typeof LayoutSensoryRoute
  InvitationTypesIndexRoute: typeof InvitationTypesIndexRoute
  InvitationsIndexRoute: typeof InvitationsIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  OrganizationsOrganizationNumberEditRoute: typeof OrganizationsOrganizationNumberEditRoute
  RemaGroupsGroupNumberRoute: typeof RemaGroupsGroupNumberRoute
  RemaGroupsAddRoute: typeof RemaGroupsAddRoute
  RemaPoliciesPolicyNumberRoute: typeof RemaPoliciesPolicyNumberRoute
  RemaPoliciesAddRoute: typeof RemaPoliciesAddRoute
  RemaResourceInstancesInstanceNumberRoute: typeof RemaResourceInstancesInstanceNumberRoute
  RemaResourceInstancesAddRoute: typeof RemaResourceInstancesAddRoute
  RemaResourceTypesResourceTypeNumberRoute: typeof RemaResourceTypesResourceTypeNumberRoute
  RemaResourceTypesAddRoute: typeof RemaResourceTypesAddRoute
  RemaRolesRoleNumberRoute: typeof RemaRolesRoleNumberRoute
  RemaRolesAddRoute: typeof RemaRolesAddRoute
  SensnetNetworkCorridorsCorridorNumberRoute: typeof SensnetNetworkCorridorsCorridorNumberRoute
  SensnetNetworkSitesSiteNumberRoute: typeof SensnetNetworkSitesSiteNumberRoute
  SensnetSensingStationsStationNumberRoute: typeof SensnetSensingStationsStationNumberRoute
  SensoryDeviceProfilesDeviceProfileNumberRoute: typeof SensoryDeviceProfilesDeviceProfileNumberRoute
  SensoryDeviceTypesDeviceTypeNumberRoute: typeof SensoryDeviceTypesDeviceTypeNumberRoute
  SensoryDevicesDeviceNumberRoute: typeof SensoryDevicesDeviceNumberRoute
  SensoryDistributorsDistributorNumberRoute: typeof SensoryDistributorsDistributorNumberRoute
  SensoryManufacturersManufacturerNumberRoute: typeof SensoryManufacturersManufacturerNumberRoute
  UsersUserNumberEditRoute: typeof UsersUserNumberEditRoute
  EventsActionsIndexRoute: typeof EventsActionsIndexRoute
  EventsEntityTypesIndexRoute: typeof EventsEntityTypesIndexRoute
  EventsEventTypesIndexRoute: typeof EventsEventTypesIndexRoute
  OrganizationsOrganizationNumberIndexRoute: typeof OrganizationsOrganizationNumberIndexRoute
  RemaControlPlaneResourceInstancesIndexRoute: typeof RemaControlPlaneResourceInstancesIndexRoute
  RemaGroupsIndexRoute: typeof RemaGroupsIndexRoute
  RemaPoliciesIndexRoute: typeof RemaPoliciesIndexRoute
  RemaResourceInstancesIndexRoute: typeof RemaResourceInstancesIndexRoute
  RemaResourceTypesIndexRoute: typeof RemaResourceTypesIndexRoute
  RemaRolesIndexRoute: typeof RemaRolesIndexRoute
  SensnetNetworkCorridorsIndexRoute: typeof SensnetNetworkCorridorsIndexRoute
  SensnetNetworkSitesIndexRoute: typeof SensnetNetworkSitesIndexRoute
  SensnetSensingStationsIndexRoute: typeof SensnetSensingStationsIndexRoute
  SensoryDeviceManagementIndexRoute: typeof SensoryDeviceManagementIndexRoute
  SensoryDeviceProfilesIndexRoute: typeof SensoryDeviceProfilesIndexRoute
  SensoryDeviceTypesIndexRoute: typeof SensoryDeviceTypesIndexRoute
  SensoryDevicesIndexRoute: typeof SensoryDevicesIndexRoute
  SensoryDistributorsIndexRoute: typeof SensoryDistributorsIndexRoute
  SensoryManufacturersIndexRoute: typeof SensoryManufacturersIndexRoute
  UsersUserNumberIndexRoute: typeof UsersUserNumberIndexRoute
  RemaGroupsGroupNumberEditRoute: typeof RemaGroupsGroupNumberEditRoute
  RemaPoliciesPolicyNumberEditRoute: typeof RemaPoliciesPolicyNumberEditRoute
  RemaResourceInstancesInstanceNumberEditRoute: typeof RemaResourceInstancesInstanceNumberEditRoute
  RemaResourceTypesResourceTypeNumberEditRoute: typeof RemaResourceTypesResourceTypeNumberEditRoute
  RemaRolesRoleNumberEditRoute: typeof RemaRolesRoleNumberEditRoute
  SensnetNetworkCorridorsNetworkCorridorNumberEditRoute: typeof SensnetNetworkCorridorsNetworkCorridorNumberEditRoute
  SensnetNetworkSitesNetworkSiteNumberEditRoute: typeof SensnetNetworkSitesNetworkSiteNumberEditRoute
  SensnetSensingStationsStationNumberEditRoute: typeof SensnetSensingStationsStationNumberEditRoute
  SensoryDeviceProfilesDeviceProfileNumberEditRoute: typeof SensoryDeviceProfilesDeviceProfileNumberEditRoute
  SensoryDeviceTypesDeviceTypeNumberEditRoute: typeof SensoryDeviceTypesDeviceTypeNumberEditRoute
  SensoryDevicesDeviceNumberEditRoute: typeof SensoryDevicesDeviceNumberEditRoute
  SensoryDistributorsDistributorNumberEditRoute: typeof SensoryDistributorsDistributorNumberEditRoute
  SensoryManufacturersManufacturerNumberEditRoute: typeof SensoryManufacturersManufacturerNumberEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/root': {
      id: '/root'
      path: '/root'
      fullPath: '/root'
      preLoaderRoute: typeof RootRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-redirect': {
      id: '/auth-redirect'
      path: '/auth-redirect'
      fullPath: '/auth-redirect'
      preLoaderRoute: typeof AuthRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-docs': {
      id: '/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof ApiDocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_frame': {
      id: '/_frame'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FrameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/': {
      id: '/invitations/'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof InvitationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation-types/': {
      id: '/invitation-types/'
      path: '/invitation-types'
      fullPath: '/invitation-types'
      preLoaderRoute: typeof InvitationTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-docs/': {
      id: '/api-docs/'
      path: '/'
      fullPath: '/api-docs/'
      preLoaderRoute: typeof ApiDocsIndexRouteImport
      parentRoute: typeof ApiDocsRoute
    }
    '/layout/sensory': {
      id: '/layout/sensory'
      path: '/layout/sensory'
      fullPath: '/layout/sensory'
      preLoaderRoute: typeof LayoutSensoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/layout/frame': {
      id: '/layout/frame'
      path: '/layout/frame'
      fullPath: '/layout/frame'
      preLoaderRoute: typeof LayoutFrameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-docs/farmgrid': {
      id: '/api-docs/farmgrid'
      path: '/farmgrid'
      fullPath: '/api-docs/farmgrid'
      preLoaderRoute: typeof ApiDocsFarmgridRouteImport
      parentRoute: typeof ApiDocsRoute
    }
    '/api-docs/conex': {
      id: '/api-docs/conex'
      path: '/conex'
      fullPath: '/api-docs/conex'
      preLoaderRoute: typeof ApiDocsConexRouteImport
      parentRoute: typeof ApiDocsRoute
    }
    '/users/$userNumber/': {
      id: '/users/$userNumber/'
      path: '/users/$userNumber'
      fullPath: '/users/$userNumber'
      preLoaderRoute: typeof UsersUserNumberIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/manufacturers/': {
      id: '/sensory/manufacturers/'
      path: '/sensory/manufacturers'
      fullPath: '/sensory/manufacturers'
      preLoaderRoute: typeof SensoryManufacturersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/distributors/': {
      id: '/sensory/distributors/'
      path: '/sensory/distributors'
      fullPath: '/sensory/distributors'
      preLoaderRoute: typeof SensoryDistributorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/devices/': {
      id: '/sensory/devices/'
      path: '/sensory/devices'
      fullPath: '/sensory/devices'
      preLoaderRoute: typeof SensoryDevicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/device-types/': {
      id: '/sensory/device-types/'
      path: '/sensory/device-types'
      fullPath: '/sensory/device-types'
      preLoaderRoute: typeof SensoryDeviceTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/device-profiles/': {
      id: '/sensory/device-profiles/'
      path: '/sensory/device-profiles'
      fullPath: '/sensory/device-profiles'
      preLoaderRoute: typeof SensoryDeviceProfilesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/device-management/': {
      id: '/sensory/device-management/'
      path: '/sensory/device-management'
      fullPath: '/sensory/device-management'
      preLoaderRoute: typeof SensoryDeviceManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/sensing-stations/': {
      id: '/sensnet/sensing-stations/'
      path: '/sensnet/sensing-stations'
      fullPath: '/sensnet/sensing-stations'
      preLoaderRoute: typeof SensnetSensingStationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/network-sites/': {
      id: '/sensnet/network-sites/'
      path: '/sensnet/network-sites'
      fullPath: '/sensnet/network-sites'
      preLoaderRoute: typeof SensnetNetworkSitesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/network-corridors/': {
      id: '/sensnet/network-corridors/'
      path: '/sensnet/network-corridors'
      fullPath: '/sensnet/network-corridors'
      preLoaderRoute: typeof SensnetNetworkCorridorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/roles/': {
      id: '/rema/roles/'
      path: '/rema/roles'
      fullPath: '/rema/roles'
      preLoaderRoute: typeof RemaRolesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-types/': {
      id: '/rema/resource-types/'
      path: '/rema/resource-types'
      fullPath: '/rema/resource-types'
      preLoaderRoute: typeof RemaResourceTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-instances/': {
      id: '/rema/resource-instances/'
      path: '/rema/resource-instances'
      fullPath: '/rema/resource-instances'
      preLoaderRoute: typeof RemaResourceInstancesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/policies/': {
      id: '/rema/policies/'
      path: '/rema/policies'
      fullPath: '/rema/policies'
      preLoaderRoute: typeof RemaPoliciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/groups/': {
      id: '/rema/groups/'
      path: '/rema/groups'
      fullPath: '/rema/groups'
      preLoaderRoute: typeof RemaGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/control-plane-resource-instances/': {
      id: '/rema/control-plane-resource-instances/'
      path: '/rema/control-plane-resource-instances'
      fullPath: '/rema/control-plane-resource-instances'
      preLoaderRoute: typeof RemaControlPlaneResourceInstancesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$organizationNumber/': {
      id: '/organizations/$organizationNumber/'
      path: '/organizations/$organizationNumber'
      fullPath: '/organizations/$organizationNumber'
      preLoaderRoute: typeof OrganizationsOrganizationNumberIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/event-types/': {
      id: '/events/event-types/'
      path: '/events/event-types'
      fullPath: '/events/event-types'
      preLoaderRoute: typeof EventsEventTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/entity-types/': {
      id: '/events/entity-types/'
      path: '/events/entity-types'
      fullPath: '/events/entity-types'
      preLoaderRoute: typeof EventsEntityTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/actions/': {
      id: '/events/actions/'
      path: '/events/actions'
      fullPath: '/events/actions'
      preLoaderRoute: typeof EventsActionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userNumber_/edit': {
      id: '/users/$userNumber_/edit'
      path: '/users/$userNumber/edit'
      fullPath: '/users/$userNumber/edit'
      preLoaderRoute: typeof UsersUserNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/manufacturers/$manufacturerNumber': {
      id: '/sensory/manufacturers/$manufacturerNumber'
      path: '/sensory/manufacturers/$manufacturerNumber'
      fullPath: '/sensory/manufacturers/$manufacturerNumber'
      preLoaderRoute: typeof SensoryManufacturersManufacturerNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/distributors/$distributorNumber': {
      id: '/sensory/distributors/$distributorNumber'
      path: '/sensory/distributors/$distributorNumber'
      fullPath: '/sensory/distributors/$distributorNumber'
      preLoaderRoute: typeof SensoryDistributorsDistributorNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/devices/$deviceNumber': {
      id: '/sensory/devices/$deviceNumber'
      path: '/sensory/devices/$deviceNumber'
      fullPath: '/sensory/devices/$deviceNumber'
      preLoaderRoute: typeof SensoryDevicesDeviceNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/device-types/$deviceTypeNumber': {
      id: '/sensory/device-types/$deviceTypeNumber'
      path: '/sensory/device-types/$deviceTypeNumber'
      fullPath: '/sensory/device-types/$deviceTypeNumber'
      preLoaderRoute: typeof SensoryDeviceTypesDeviceTypeNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/device-profiles/$deviceProfileNumber': {
      id: '/sensory/device-profiles/$deviceProfileNumber'
      path: '/sensory/device-profiles/$deviceProfileNumber'
      fullPath: '/sensory/device-profiles/$deviceProfileNumber'
      preLoaderRoute: typeof SensoryDeviceProfilesDeviceProfileNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/sensing-stations/$stationNumber': {
      id: '/sensnet/sensing-stations/$stationNumber'
      path: '/sensnet/sensing-stations/$stationNumber'
      fullPath: '/sensnet/sensing-stations/$stationNumber'
      preLoaderRoute: typeof SensnetSensingStationsStationNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/network-sites/$siteNumber': {
      id: '/sensnet/network-sites/$siteNumber'
      path: '/sensnet/network-sites/$siteNumber'
      fullPath: '/sensnet/network-sites/$siteNumber'
      preLoaderRoute: typeof SensnetNetworkSitesSiteNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/network-corridors/$corridorNumber': {
      id: '/sensnet/network-corridors/$corridorNumber'
      path: '/sensnet/network-corridors/$corridorNumber'
      fullPath: '/sensnet/network-corridors/$corridorNumber'
      preLoaderRoute: typeof SensnetNetworkCorridorsCorridorNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/roles/add': {
      id: '/rema/roles/add'
      path: '/rema/roles/add'
      fullPath: '/rema/roles/add'
      preLoaderRoute: typeof RemaRolesAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/roles/$roleNumber': {
      id: '/rema/roles/$roleNumber'
      path: '/rema/roles/$roleNumber'
      fullPath: '/rema/roles/$roleNumber'
      preLoaderRoute: typeof RemaRolesRoleNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-types/add': {
      id: '/rema/resource-types/add'
      path: '/rema/resource-types/add'
      fullPath: '/rema/resource-types/add'
      preLoaderRoute: typeof RemaResourceTypesAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-types/$resourceTypeNumber': {
      id: '/rema/resource-types/$resourceTypeNumber'
      path: '/rema/resource-types/$resourceTypeNumber'
      fullPath: '/rema/resource-types/$resourceTypeNumber'
      preLoaderRoute: typeof RemaResourceTypesResourceTypeNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-instances/add': {
      id: '/rema/resource-instances/add'
      path: '/rema/resource-instances/add'
      fullPath: '/rema/resource-instances/add'
      preLoaderRoute: typeof RemaResourceInstancesAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-instances/$instanceNumber': {
      id: '/rema/resource-instances/$instanceNumber'
      path: '/rema/resource-instances/$instanceNumber'
      fullPath: '/rema/resource-instances/$instanceNumber'
      preLoaderRoute: typeof RemaResourceInstancesInstanceNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/policies/add': {
      id: '/rema/policies/add'
      path: '/rema/policies/add'
      fullPath: '/rema/policies/add'
      preLoaderRoute: typeof RemaPoliciesAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/policies/$policyNumber': {
      id: '/rema/policies/$policyNumber'
      path: '/rema/policies/$policyNumber'
      fullPath: '/rema/policies/$policyNumber'
      preLoaderRoute: typeof RemaPoliciesPolicyNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/groups/add': {
      id: '/rema/groups/add'
      path: '/rema/groups/add'
      fullPath: '/rema/groups/add'
      preLoaderRoute: typeof RemaGroupsAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/groups/$groupNumber': {
      id: '/rema/groups/$groupNumber'
      path: '/rema/groups/$groupNumber'
      fullPath: '/rema/groups/$groupNumber'
      preLoaderRoute: typeof RemaGroupsGroupNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$organizationNumber_/edit': {
      id: '/organizations/$organizationNumber_/edit'
      path: '/organizations/$organizationNumber/edit'
      fullPath: '/organizations/$organizationNumber/edit'
      preLoaderRoute: typeof OrganizationsOrganizationNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/manufacturers/$manufacturerNumber_/edit': {
      id: '/sensory/manufacturers/$manufacturerNumber_/edit'
      path: '/sensory/manufacturers/$manufacturerNumber/edit'
      fullPath: '/sensory/manufacturers/$manufacturerNumber/edit'
      preLoaderRoute: typeof SensoryManufacturersManufacturerNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/distributors/$distributorNumber_/edit': {
      id: '/sensory/distributors/$distributorNumber_/edit'
      path: '/sensory/distributors/$distributorNumber/edit'
      fullPath: '/sensory/distributors/$distributorNumber/edit'
      preLoaderRoute: typeof SensoryDistributorsDistributorNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/devices/$deviceNumber_/edit': {
      id: '/sensory/devices/$deviceNumber_/edit'
      path: '/sensory/devices/$deviceNumber/edit'
      fullPath: '/sensory/devices/$deviceNumber/edit'
      preLoaderRoute: typeof SensoryDevicesDeviceNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/device-types/$deviceTypeNumber_/edit': {
      id: '/sensory/device-types/$deviceTypeNumber_/edit'
      path: '/sensory/device-types/$deviceTypeNumber/edit'
      fullPath: '/sensory/device-types/$deviceTypeNumber/edit'
      preLoaderRoute: typeof SensoryDeviceTypesDeviceTypeNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensory/device-profiles/$deviceProfileNumber_/edit': {
      id: '/sensory/device-profiles/$deviceProfileNumber_/edit'
      path: '/sensory/device-profiles/$deviceProfileNumber/edit'
      fullPath: '/sensory/device-profiles/$deviceProfileNumber/edit'
      preLoaderRoute: typeof SensoryDeviceProfilesDeviceProfileNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/sensing-stations/$stationNumber_/edit': {
      id: '/sensnet/sensing-stations/$stationNumber_/edit'
      path: '/sensnet/sensing-stations/$stationNumber/edit'
      fullPath: '/sensnet/sensing-stations/$stationNumber/edit'
      preLoaderRoute: typeof SensnetSensingStationsStationNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/network-sites/$networkSiteNumber_/edit': {
      id: '/sensnet/network-sites/$networkSiteNumber_/edit'
      path: '/sensnet/network-sites/$networkSiteNumber/edit'
      fullPath: '/sensnet/network-sites/$networkSiteNumber/edit'
      preLoaderRoute: typeof SensnetNetworkSitesNetworkSiteNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensnet/network-corridors/$networkCorridorNumber_/edit': {
      id: '/sensnet/network-corridors/$networkCorridorNumber_/edit'
      path: '/sensnet/network-corridors/$networkCorridorNumber/edit'
      fullPath: '/sensnet/network-corridors/$networkCorridorNumber/edit'
      preLoaderRoute: typeof SensnetNetworkCorridorsNetworkCorridorNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/roles/$roleNumber_/edit': {
      id: '/rema/roles/$roleNumber_/edit'
      path: '/rema/roles/$roleNumber/edit'
      fullPath: '/rema/roles/$roleNumber/edit'
      preLoaderRoute: typeof RemaRolesRoleNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-types/$resourceTypeNumber_/edit': {
      id: '/rema/resource-types/$resourceTypeNumber_/edit'
      path: '/rema/resource-types/$resourceTypeNumber/edit'
      fullPath: '/rema/resource-types/$resourceTypeNumber/edit'
      preLoaderRoute: typeof RemaResourceTypesResourceTypeNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/resource-instances/$instanceNumber_/edit': {
      id: '/rema/resource-instances/$instanceNumber_/edit'
      path: '/rema/resource-instances/$instanceNumber/edit'
      fullPath: '/rema/resource-instances/$instanceNumber/edit'
      preLoaderRoute: typeof RemaResourceInstancesInstanceNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/policies/$policyNumber_/edit': {
      id: '/rema/policies/$policyNumber_/edit'
      path: '/rema/policies/$policyNumber/edit'
      fullPath: '/rema/policies/$policyNumber/edit'
      preLoaderRoute: typeof RemaPoliciesPolicyNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rema/groups/$groupNumber_/edit': {
      id: '/rema/groups/$groupNumber_/edit'
      path: '/rema/groups/$groupNumber/edit'
      fullPath: '/rema/groups/$groupNumber/edit'
      preLoaderRoute: typeof RemaGroupsGroupNumberEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ApiDocsRouteChildren {
  ApiDocsConexRoute: typeof ApiDocsConexRoute
  ApiDocsFarmgridRoute: typeof ApiDocsFarmgridRoute
  ApiDocsIndexRoute: typeof ApiDocsIndexRoute
}

const ApiDocsRouteChildren: ApiDocsRouteChildren = {
  ApiDocsConexRoute: ApiDocsConexRoute,
  ApiDocsFarmgridRoute: ApiDocsFarmgridRoute,
  ApiDocsIndexRoute: ApiDocsIndexRoute,
}

const ApiDocsRouteWithChildren =
  ApiDocsRoute._addFileChildren(ApiDocsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FrameRoute: FrameRoute,
  ApiDocsRoute: ApiDocsRouteWithChildren,
  AuthRedirectRoute: AuthRedirectRoute,
  HomeRoute: HomeRoute,
  RootRoute: RootRoute,
  SigninRoute: SigninRoute,
  LayoutFrameRoute: LayoutFrameRoute,
  LayoutSensoryRoute: LayoutSensoryRoute,
  InvitationTypesIndexRoute: InvitationTypesIndexRoute,
  InvitationsIndexRoute: InvitationsIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  OrganizationsOrganizationNumberEditRoute:
    OrganizationsOrganizationNumberEditRoute,
  RemaGroupsGroupNumberRoute: RemaGroupsGroupNumberRoute,
  RemaGroupsAddRoute: RemaGroupsAddRoute,
  RemaPoliciesPolicyNumberRoute: RemaPoliciesPolicyNumberRoute,
  RemaPoliciesAddRoute: RemaPoliciesAddRoute,
  RemaResourceInstancesInstanceNumberRoute:
    RemaResourceInstancesInstanceNumberRoute,
  RemaResourceInstancesAddRoute: RemaResourceInstancesAddRoute,
  RemaResourceTypesResourceTypeNumberRoute:
    RemaResourceTypesResourceTypeNumberRoute,
  RemaResourceTypesAddRoute: RemaResourceTypesAddRoute,
  RemaRolesRoleNumberRoute: RemaRolesRoleNumberRoute,
  RemaRolesAddRoute: RemaRolesAddRoute,
  SensnetNetworkCorridorsCorridorNumberRoute:
    SensnetNetworkCorridorsCorridorNumberRoute,
  SensnetNetworkSitesSiteNumberRoute: SensnetNetworkSitesSiteNumberRoute,
  SensnetSensingStationsStationNumberRoute:
    SensnetSensingStationsStationNumberRoute,
  SensoryDeviceProfilesDeviceProfileNumberRoute:
    SensoryDeviceProfilesDeviceProfileNumberRoute,
  SensoryDeviceTypesDeviceTypeNumberRoute:
    SensoryDeviceTypesDeviceTypeNumberRoute,
  SensoryDevicesDeviceNumberRoute: SensoryDevicesDeviceNumberRoute,
  SensoryDistributorsDistributorNumberRoute:
    SensoryDistributorsDistributorNumberRoute,
  SensoryManufacturersManufacturerNumberRoute:
    SensoryManufacturersManufacturerNumberRoute,
  UsersUserNumberEditRoute: UsersUserNumberEditRoute,
  EventsActionsIndexRoute: EventsActionsIndexRoute,
  EventsEntityTypesIndexRoute: EventsEntityTypesIndexRoute,
  EventsEventTypesIndexRoute: EventsEventTypesIndexRoute,
  OrganizationsOrganizationNumberIndexRoute:
    OrganizationsOrganizationNumberIndexRoute,
  RemaControlPlaneResourceInstancesIndexRoute:
    RemaControlPlaneResourceInstancesIndexRoute,
  RemaGroupsIndexRoute: RemaGroupsIndexRoute,
  RemaPoliciesIndexRoute: RemaPoliciesIndexRoute,
  RemaResourceInstancesIndexRoute: RemaResourceInstancesIndexRoute,
  RemaResourceTypesIndexRoute: RemaResourceTypesIndexRoute,
  RemaRolesIndexRoute: RemaRolesIndexRoute,
  SensnetNetworkCorridorsIndexRoute: SensnetNetworkCorridorsIndexRoute,
  SensnetNetworkSitesIndexRoute: SensnetNetworkSitesIndexRoute,
  SensnetSensingStationsIndexRoute: SensnetSensingStationsIndexRoute,
  SensoryDeviceManagementIndexRoute: SensoryDeviceManagementIndexRoute,
  SensoryDeviceProfilesIndexRoute: SensoryDeviceProfilesIndexRoute,
  SensoryDeviceTypesIndexRoute: SensoryDeviceTypesIndexRoute,
  SensoryDevicesIndexRoute: SensoryDevicesIndexRoute,
  SensoryDistributorsIndexRoute: SensoryDistributorsIndexRoute,
  SensoryManufacturersIndexRoute: SensoryManufacturersIndexRoute,
  UsersUserNumberIndexRoute: UsersUserNumberIndexRoute,
  RemaGroupsGroupNumberEditRoute: RemaGroupsGroupNumberEditRoute,
  RemaPoliciesPolicyNumberEditRoute: RemaPoliciesPolicyNumberEditRoute,
  RemaResourceInstancesInstanceNumberEditRoute:
    RemaResourceInstancesInstanceNumberEditRoute,
  RemaResourceTypesResourceTypeNumberEditRoute:
    RemaResourceTypesResourceTypeNumberEditRoute,
  RemaRolesRoleNumberEditRoute: RemaRolesRoleNumberEditRoute,
  SensnetNetworkCorridorsNetworkCorridorNumberEditRoute:
    SensnetNetworkCorridorsNetworkCorridorNumberEditRoute,
  SensnetNetworkSitesNetworkSiteNumberEditRoute:
    SensnetNetworkSitesNetworkSiteNumberEditRoute,
  SensnetSensingStationsStationNumberEditRoute:
    SensnetSensingStationsStationNumberEditRoute,
  SensoryDeviceProfilesDeviceProfileNumberEditRoute:
    SensoryDeviceProfilesDeviceProfileNumberEditRoute,
  SensoryDeviceTypesDeviceTypeNumberEditRoute:
    SensoryDeviceTypesDeviceTypeNumberEditRoute,
  SensoryDevicesDeviceNumberEditRoute: SensoryDevicesDeviceNumberEditRoute,
  SensoryDistributorsDistributorNumberEditRoute:
    SensoryDistributorsDistributorNumberEditRoute,
  SensoryManufacturersManufacturerNumberEditRoute:
    SensoryManufacturersManufacturerNumberEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
